import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import GeneralInput from "components/GeneralInput";
import SimpleToast from "components/SimpleToast";
import Switch from "components/Switch";

import { LogOperation } from "utils/entities/logOperation";
import { stringFormat } from "utils/stringFormat";

import { post, put } from "./constants";
import { IFormOneLabel, IFormPost } from "./interface";
import { ContainerFormOneLabel, ContainerFormOneLabelSwitch } from "./styles";

type toastOption = "success" | "warning" | "error";

export const FormOneLabel: React.FC<IFormOneLabel> = ({
  displayLabel,
  customerId,
  modelFormBase,
  titleToast,
}) => {
  const { t } = useTranslation();
  const editItem = modelFormBase.objectRetorned as IFormOneLabel;

  const [text, setText] = useState<string>(editItem ? editItem?.name : "");
  const [activeAux, setActiveAux] = useState<boolean>(
    editItem ? editItem.active : true,
  );

  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [toastTrigger, setToastTrigger] = useState<number>(0);
  const [toastTitle, setToastTitle] = useState<string>(titleToast);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastType, setToastType] = useState<toastOption>("warning");

  const idAux = editItem ? editItem?.id : 0;

  useEffect(() => {
    setLoading(true);
    const handleSubmitForm = async () => {
      if (modelFormBase.onSubmitForm > 0) {
        const operationType = modelFormBase.httpType;
        try {
          let objectRetorned = null;
          if (textIsEmpty(text)) {
            setError(true);
            configureToast(
              `Para criar ${titleToast.toLocaleLowerCase()} é necessário preencher os campos destacados`,
              "warning",
            );

            modelFormBase.setOnSubmitForm(0);
            return;
          }

          if (listContainsText()) {
            setError(true);
            configureToast(
              `${titleToast.toLocaleLowerCase()} já existe`,
              "warning",
            );

            modelFormBase.setOnSubmitForm(0);
            return;
          }

          if (operationType === "post") {
            objectRetorned = await post(
              handleCreateObjectToHttpType(),
              modelFormBase.endPoint,
            );
          } else if (operationType === "put") {
            objectRetorned = await put(
              handleCreateObjectToHttpType(),
              modelFormBase.endPoint,
            );
          }
          setError(false);
          modelFormBase.setObjectRetorned(objectRetorned);
        } catch (e: any) {
          if (e?.message === "PERMISSION_DENIED" || e?.status === 403) {
            setToastTitle("Acesso negado");

            if (operationType === "post") {
              setToastBody(
                "Você não tem permissão para criar um participante.",
              );
            } else if (operationType === "put") {
              setToastBody(
                "Você não tem permissão para editar um participante.",
              );
            }

            setToastType("error");
            setToastTrigger((prev) => prev + 1);
          } else {
            configureToast("Ocorreu erro inesperado", "error");
          }
        }
      }
    };

    setLoading(false);
    handleSubmitForm();
  }, [modelFormBase.onSubmitForm]);

  const handleCreateObjectToHttpType = (): IFormPost => ({
    id: idAux,
    active: activeAux,
    customerId: customerId,
    name: text,
    device: LogOperation.getDevice(),
    ip: LogOperation.getMachineIP(),
    logPoliceUnitId: LogOperation.getPoliceUnitId(),
    logUserId: LogOperation.getUserId(),
  });

  const textIsEmpty = (name: string) => {
    const isEmpty = stringFormat.isEmptyOrSpaces(name);
    if (isEmpty) {
      setError(true);
      return true;
    } else {
      setError(false);
      return false;
    }
  };

  const listContainsText = () => {
    if (modelFormBase.list) {
      const contains = stringFormat.verifyExistNameInArray(
        modelFormBase.list,
        text,
        idAux,
      );

      if (contains) {
        setError(true);
        return true;
      } else {
        setError(false);
        return false;
      }
    }
    return false;
  };

  const configureToast = (
    toastBodyMessage: string,
    toastOption: toastOption,
  ) => {
    setToastTitle(titleToast);
    setToastBody(toastBodyMessage);
    setToastType(toastOption);
    setToastTrigger(toastTrigger + 1);
  };

  return (
    <>
      {!loading ? (
        <>
          <SimpleToast
            id="attendantRoleToastId"
            title={toastTitle}
            type={toastType}
            description={toastBody}
            handleCloseToast={() => {}}
            trigger={toastTrigger}
          />
          <ContainerFormOneLabel>
            <ContainerFormOneLabelSwitch>
              <Switch
                dataTest="switch_active"
                onChange={() => setActiveAux(!activeAux)}
                checked={activeAux}
                label={t("common.active")}
              />
            </ContainerFormOneLabelSwitch>
            <GeneralInput
              id="title"
              label={displayLabel}
              name="formOneLabel"
              onChange={setText}
              value={text}
              error={error}
              required
              marginRight="0px"
              maxLength={90}
            />
          </ContainerFormOneLabel>
        </>
      ) : null}
    </>
  );
};
